import { injectIntl } from 'react-intl';
import compose from 'lodash.flowright';

import { xingConnect } from '@xingternal/frame-data-provider';

import { LayoutClassic as LayoutClassicComponent } from './LayoutClassic';
import { layoutClassicSelector } from './LayoutClassic.selectors';

const LayoutClassic = compose(
  xingConnect(layoutClassicSelector),
  injectIntl
)(LayoutClassicComponent);
export { LayoutClassic };
